export default __webpack_public_path__ + "static/media/teams.719a7127.svg";